/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useState } from 'react';
import { useParams, useHistory } from 'react-router-dom';
import * as Yup from 'yup';
import clsx from 'clsx';
import { useFormik } from 'formik';
import { createPass } from '../../service/users/Usuarios';
import { toast } from 'react-toastify';
import { SimpleAlert, toAbsoluteUrl } from '../../../_mexablock/helpers';

interface Params {
  token?: string;
}

export function CreatePass() {
  const { token } = useParams<Params>();
  const history = useHistory();

  const [loading, setLoading] = useState(false);
  const [visivility, setVisivility] = useState(false);
  const [visivilityFirst, setVisivilityFirst] = useState(false);

  const validateVisibility = () => setVisivility(!visivility);
  const validateVisibilityFirst = () => setVisivilityFirst(!visivilityFirst);

  const confirmPasswordSchema = Yup.object().shape({
    password: Yup.string()
      .required('La contraseña es obligatoria.')
      .min(8, 'La contraseña debe tener al menos 8 caracteres.')
      .max(20, 'La contraseña no debe superar los 20 caracteres.')
      .matches(/[A-Z]/, 'Debe contener al menos una letra mayúscula.')
      .matches(/[a-z]/, 'Debe contener al menos una letra minúscula.')
      .matches(/[0-9]/, 'Debe incluir al menos un número.')
      .matches(
        /[@#$%^&\-+=()]/,
        'Debe incluir al menos un carácter especial (@, #, $, %, ^, &, -, +, =, (, )).',
      )
      .matches(/^\S*$/, 'No debe contener espacios en blanco.'),
    confirmPassword: Yup.string()
      .required('Por favor confirma tu contraseña.')
      .oneOf([Yup.ref('password'), null], 'Las contraseñas no coinciden.'),
  });

  const initialValues = {
    password: '',
    confirmPassword: '',
    secretKey: token,
  };

  const formik = useFormik({
    initialValues,
    validationSchema: confirmPasswordSchema,
    onSubmit: (values, { setStatus, setSubmitting }) => {
      setLoading(true);

      setTimeout(() => {
        createPass(values)
          .then(() => {
            setLoading(false);
            toast(`Se actualizaron los datos correctamente!`, {
              position: 'top-center',
              autoClose: 3000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
              theme: 'light',
            });
            history.push('/auth/login');
          })
          .catch((err) => {
            let resMessageToast: string = '';

            if (err.response && err.response.data) {
              const {
                data: { message, details = null },
              } = err.response;

              resMessageToast = `${message}`;
              if (details?.length) {
                setStatus(`${details[0]?.message}`);
              }
            } else {
              resMessageToast = 'Error al crear contraseña';
            }

            setLoading(false);
            setSubmitting(false);
            SimpleAlert(resMessageToast, 3000, 'error');
          });
      }, 1000);
    },
  });

  return (
    <div className="d-flex flex-column flex-root">
      <div className="d-flex flex-column flex-column-fluid align-items-center justify-content-center p-10">
        <div className="text-center mb-8">
          <img
            alt="Logo softnet"
            src={toAbsoluteUrl('/media/logos/logo-softnet.svg')}
            className="w-150px"
          />
        </div>

        <div className="w-100" style={{ maxWidth: 520 }}>
          <div className="card shadow-sm">
            <div className="card-body p-8 p-sm-10">
              <form
                className="form w-100"
                onSubmit={formik.handleSubmit}
                noValidate
                id="kt_login_signin_form"
              >
                <div className="text-center mb-8">
                  <h1 className="text-dark mb-3 fs-3">Crear contraseña</h1>
                  <div className="text-gray-600 fs-6">
                    Tu contraseña debe tener al menos 8 caracteres, incluyendo
                    mayúsculas, minúsculas, números y símbolos.
                  </div>
                </div>

                {formik.status && (
                  <div className="mb-8 alert alert-danger">
                    <div className="alert-text fw-bold">{formik.status}</div>
                  </div>
                )}

                <div className="fv-row mb-8">
                  <label className="form-label fw-bolder text-dark fs-6 mb-2">
                    Ingresa la contraseña
                  </label>

                  <div className={clsx('position-relative')}>
                    <input
                      type={visivilityFirst ? 'text' : 'password'}
                      placeholder="Contraseña"
                      autoComplete="off"
                      maxLength={20}
                      {...formik.getFieldProps('password')}
                      className={clsx('form-control form-control-lg', {
                        'is-invalid':
                          formik.touched.password && !!formik.errors.password,
                      })}
                    />
                    <span
                      className={clsx(
                        'btn btn-sm btn-icon position-absolute translate-middle top-50 end-0 me-n2',
                      )}
                      onClick={validateVisibilityFirst}
                      role="button"
                      tabIndex={0}
                    >
                      {visivilityFirst ? (
                        <i className={clsx('bi bi-eye fs-2')}></i>
                      ) : (
                        <i className={clsx('bi bi-eye-slash fs-2')}></i>
                      )}
                    </span>
                  </div>

                  {formik.touched.password && formik.errors.password && (
                    <div className="fv-plugins-message-container text-danger mt-3">
                      <div className="fv-help-block">
                        <span role="alert">{formik.errors.password}</span>
                      </div>
                    </div>
                  )}
                </div>

                {/* Confirm Password */}
                <div className="fv-row mb-8">
                  <label className="form-label fw-bolder text-dark fs-6 mb-2">
                    Confirmar contraseña
                  </label>

                  <div className={clsx('position-relative')}>
                    <input
                      type={visivility ? 'text' : 'password'}
                      placeholder="Confirmar contraseña"
                      autoComplete="off"
                      maxLength={20}
                      {...formik.getFieldProps('confirmPassword')}
                      className={clsx('form-control form-control-lg', {
                        'is-invalid':
                          formik.touched.confirmPassword &&
                          !!formik.errors.confirmPassword,
                      })}
                    />
                    <span
                      className={clsx(
                        'btn btn-sm btn-icon position-absolute translate-middle top-50 end-0 me-n2',
                      )}
                      onClick={validateVisibility}
                      role="button"
                      tabIndex={0}
                    >
                      {visivility ? (
                        <i className={clsx('bi bi-eye fs-2')}></i>
                      ) : (
                        <i className={clsx('bi bi-eye-slash fs-2')}></i>
                      )}
                    </span>
                  </div>

                  {formik.touched.confirmPassword &&
                    formik.errors.confirmPassword && (
                      <div className="fv-plugins-message-container text-danger mt-3">
                        <div className="fv-help-block">
                          <span role="alert">
                            {formik.errors.confirmPassword}
                          </span>
                        </div>
                      </div>
                    )}

                  <div className="form-text mt-4">
                    La contraseña debe tener entre 8 y 20 caracteres, incluir
                    mayúsculas, minúsculas, números y al menos uno de estos
                    signos: @ # $ % ^ & - + = ( )
                  </div>
                </div>

                {/* Submit */}
                <div className="text-center">
                  <button
                    type="submit"
                    id="kt_sign_in_submit"
                    className="btn btn-lg btn-primary w-100"
                    disabled={formik.isSubmitting || !formik.isValid || loading}
                  >
                    {!loading && (
                      <span className="indicator-label">Continuar</span>
                    )}
                    {loading && (
                      <span
                        className="indicator-progress"
                        style={{ display: 'block' }}
                      >
                        Espere por favor...
                        <span className="spinner-border spinner-border-sm align-middle ms-2"></span>
                      </span>
                    )}
                  </button>
                </div>
              </form>
            </div>
          </div>

          <div className="text-center mt-6 text-gray-500 fs-7">
            © {new Date().getFullYear()} Softnet
          </div>
        </div>
      </div>
    </div>
  );
}
